import * as DialogPrimitive from "@radix-ui/react-dialog"
import React from "react"
import { cn } from '@/utils/index'

export const DialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed  inset-0 z-50 bg-black/80 backdrop-blur-[4px]",
      className
    )}
    {...props}
  />
))
